import React, { memo, useContext } from 'react';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';
import { AppContext } from 'src/components/app-context';
import type { Location } from 'history';
import { ClassicSwitchLink } from './styles';

const ClassicSwitch: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IClassicSwitchProps>>
> = props => {
  const { utmMedium, children, location } = props;
  const context = useContext(AppContext);

  if (!context.market.showClassicSwitch || context.renderMode === 'beta') {
    return null;
  }

  return (
    <ClassicSwitchLink href={classicUrl(location, utmMedium)} rel="nofollow">
      {children}
    </ClassicSwitchLink>
  );
};

const classicUrl = (location: Location, medium?: string) => {
  const path =
    location.pathname === '/search' ? '/search.php' : location.pathname;

  const searchQuery =
    location.search && location.pathname === '/search'
      ? `?q=${location.search.split('=').pop()}`
      : location.search;

  return `/_internal/switch-platform/classic?path=${encodeURIComponent(
    `${path + searchQuery}${
      location.search ? '&' : '?'
    }utm_source=rfe-exit&utm_medium=${medium}`
  )}`;
};

interface IClassicSwitchProps extends RouteComponentProps<any> {
  utmMedium?: string;
}

export default memo<any>(withRouter(ClassicSwitch)); // Typing as any until React version is updated to 17+. It is very unlikely that wrapping it in memo is suitable.
